/* eslint-disable @typescript-eslint/no-explicit-any */
import { IParamsGetUnit } from 'app/api/hr/model'
import { UnitMessageCode } from 'app/api/unit/constant'
import { IUnit } from 'app/model/unit.model'
import { getToken } from 'app/service/storage/storage-service'
import { isEqual } from 'lodash'
import { useInfiniteQuery } from 'react-query'
import { WarehouseUnitKeys } from '../query-key/warehouse-unit'
import { requestGetWarehouseUnit } from 'app/api/inventory-new'
import { IResponseGetWarehouseUnit } from 'app/containers/InventoryManagement/Warehouse/type'

export function useGetWarehouseUnit(params: IParamsGetUnit, enabled = true) {
  const token = getToken()
  return useInfiniteQuery<IUnit[], undefined>(
    WarehouseUnitKeys.getWarehouseUnits(params),
    async () => {
      try {
        const res: IResponseGetWarehouseUnit = await requestGetWarehouseUnit()
        if (
          isEqual(res?.msgcode, UnitMessageCode.UnitManagement.successGetData)
        ) {
          const data: IUnit[] = res?.data || []
          return data
        }
        return []
      } catch (error: any) {
        return []
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}
